import YieldChart from './YieldChart';

export default YieldChart;
